import { classNames } from '../../helper/classNames';

type Props = {
  className?: string;
  isOpen: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
};

const Overlay = ({ className, isOpen, onClick }: Props) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        'fixed inset-0 bg-black transition-opacity duration-500',
        isOpen
          ? 'opacity-90 ease-[cubic-bezier(0.4,0,0.2,1)]'
          : 'opacity-0 ease-[cubic-bezier(0.8,0,0.6,1)] pointer-events-none',
        className
      )}
    />
  );
};

export default Overlay;
